import { useState } from "react";
import { CaretDown, Check } from "@phosphor-icons/react";

export const CONTACT_STATUSES = [
    "Not Contacted",
    "Called",
    "Emailed",
    "Left Voicemail",
    "Interested",
    "Call Back Later",
    "Not Interested",
    "Wrong Contact",
    "Invalid Details",
    "Claimed Business",
];

const STATUS_COLOR = {
    "Not Contacted": "dot-muted",
    "Called": "dot-success",
    "Emailed": "dot-success",
    "Left Voicemail": "dot-warning",
    "Interested": "dot-success",
    "Call Back Later": "dot-warning",
    "Not Interested": "dot-error",
    "Wrong Contact": "dot-error",
    "Invalid Details": "dot-error",
    "Claimed Business": "dot-black",
};

export default function ContactStatusSelect({ value, onChange, disabled, testId }) {
    const [open, setOpen] = useState(false);
    const status = value || "Not Contacted";
    return (
        <div className="relative" data-testid={testId}>
            <button
                type="button"
                onClick={(e) => {
                    e.stopPropagation();
                    setOpen((s) => !s);
                }}
                disabled={disabled}
                className="inline-flex items-center gap-2 px-2 py-1 mono text-[11px] border border-[#e4e4e7] hover:bg-[#fafafa] transition-colors min-w-[150px] justify-between"
                data-testid={`${testId || "status"}-trigger`}
            >
                <span className="flex items-center">
                    <span className={"dot " + (STATUS_COLOR[status] || "dot-muted")} />
                    {status}
                </span>
                <CaretDown size={10} weight="bold" />
            </button>
            {open && (
                <>
                    <div
                        className="fixed inset-0 z-10"
                        onClick={() => setOpen(false)}
                    />
                    <div
                        className="absolute right-0 mt-1 z-20 bg-white border border-black min-w-[180px]"
                        style={{ boxShadow: "4px 4px 0 rgba(0,0,0,0.08)" }}
                    >
                        {CONTACT_STATUSES.map((s) => (
                            <button
                                key={s}
                                type="button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setOpen(false);
                                    if (s !== status) onChange?.(s);
                                }}
                                className="w-full flex items-center justify-between px-3 py-2 text-left hover:bg-[#fafafa] mono text-[11px] border-b border-[#f4f4f5] last:border-b-0"
                                data-testid={`status-option-${s
                                    .toLowerCase()
                                    .replace(/\s+/g, "-")}`}
                            >
                                <span className="flex items-center">
                                    <span
                                        className={
                                            "dot " +
                                            (STATUS_COLOR[s] || "dot-muted")
                                        }
                                    />
                                    {s}
                                </span>
                                {s === status && (
                                    <Check size={12} weight="bold" />
                                )}
                            </button>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
}
